import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class CIBC_DOCUMENTS_MORTGAGE_FINAL_REPORT_Mapper extends BaseFormMapper<CIBC_DOCUMENTS_MORTGAGE_FINAL_REPORT> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: CIBC_DOCUMENTS_MORTGAGE_FINAL_REPORT,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as CIBC_DOCUMENTS_MORTGAGE_FINAL_REPORT);

		return _formData;
	}

	MapValues(): Partial<CIBC_DOCUMENTS_MORTGAGE_FINAL_REPORT> {
		return {};
	}
}

const Mappings: CIBC_DOCUMENTS_MORTGAGE_FINAL_REPORT = {
	// '0':'topmostSubform[0]',
	// '1':'topmostSubform[0].Page2[0]',
	exceptions: 'topmostSubform[0].Page2[0].INPUT15[0]',
	// '3':'topmostSubform[0].Page1[0]',
	signature: 'topmostSubform[0].Page1[0].INPUT21[0]',
	solictorName: 'topmostSubform[0].Page1[0].INPUT20[0]',
	dateYear: 'topmostSubform[0].Page1[0].INPUT19[0]',
	dateMonth: 'topmostSubform[0].Page1[0].INPUT18[0]',
	dateDay: 'topmostSubform[0].Page1[0].INPUT17[0]',
	datedAt: 'topmostSubform[0].Page1[0].INPUT16[0]',
	electronicallyRegisteredLand: 'topmostSubform[0].Page1[0].INPUT15[0]',
	province2: 'topmostSubform[0].Page1[0].DDPROVINCE2[0]',
	province1: 'topmostSubform[0].Page1[0].DDPROVINCE1[0]',
	acknowledgement: 'topmostSubform[0].Page1[0].INPUT14[0]',
	enclosures: 'topmostSubform[0].Page1[0].INPUT13[0]',
	fireInsuranceAgent: 'topmostSubform[0].Page1[0].INPUT12[0]',
	fireinsurancePolicyNumber: 'topmostSubform[0].Page1[0].INPUT11[0]',
	fireInsuranceName: 'topmostSubform[0].Page1[0].INPUT10[0]',
	selectedOption: 'topmostSubform[0].Page1[0].RadioButtonList[1]',
	taxesPaidTo: 'topmostSubform[0].Page1[0].INPUT9[0]',
	mortgageAmount: 'topmostSubform[0].Page1[0].INPUT8[0]',
	registrationDate: 'topmostSubform[0].Page1[0].INPUT7[0]',
	registryOffice: 'topmostSubform[0].Page1[0].INPUT6[0]',
	parcelIdentification: 'topmostSubform[0].Page1[0].INPUT5[0]',
	mortgageDate: 'topmostSubform[0].Page1[0].INPUT4[0]',
	registrationNumber: 'topmostSubform[0].Page1[0].INPUT3[0]',
	electronicRegistration: 'topmostSubform[0].Page1[0].RadioButtonList[0]',
	legalDescription: 'topmostSubform[0].Page1[0].INPUT2[0]',
	propertyAddress: 'topmostSubform[0].Page1[0].INPUT1[0]',
	mortgagor: 'topmostSubform[0].Page1[0].BWRLGLNM_OR_COMPANYNAME[0]',
	cibcReferenceNumber: 'topmostSubform[0].Page1[0].ID_PRET_CLIENT[0]',
	// '31':'topmostSubform[0].Page1[0].BARCODE[0]',
};

export interface CIBC_DOCUMENTS_MORTGAGE_FINAL_REPORT {
	cibcReferenceNumber: string;
	mortgagor: string;
	propertyAddress: string;
	legalDescription: string;

	electronicRegistration: string;
	registrationNumber: string;

	mortgageDate: string;
	parcelIdentification: string;

	registryOffice: string;
	registrationDate: string;

	mortgageAmount: string;
	taxesPaidTo: string;

	fireInsuranceName: string;
	fireinsurancePolicyNumber: string;
	fireInsuranceAgent: string;

	selectedOption: string;

	enclosures: string;
	acknowledgement: string;

	province1: string;
	province2: string;

	electronicallyRegisteredLand: string;

	datedAt: string;
	dateDay: string;
	dateMonth: string;
	dateYear: string;

	solictorName: string;
	signature: string;

	exceptions: string;
}
